import(/* webpackMode: "eager" */ "/home/u551131594/domains/bizzbox.social/hbuilds/source/repository/src/app/settings/page.tsx");
